import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Constants } from '../../../shared/utilities/Constants';
import { OptionDropdown, SelectControl } from '../../models/OptionDropdownSelect';
import { createControl } from '../../utilities/formUtilities';

@Component({
  standalone: false,
  selector: 'mm-ach-contribution-reason',
  templateUrl: './ach-contribution-reason.component.html',
  styleUrls: ['./ach-contribution-reason.component.scss']  
})
export class AchContributionReasonComponent implements OnInit, OnDestroy {

  @Input() parentForm: UntypedFormGroup;
  @Input() contributionOptions$: Observable<string[]>;
  controlName: string = 'contributionReason';
  contributionModel$: Observable<SelectControl>
  tooltipVerbiage: string = Constants.contributionYear;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    createControl(this.parentForm, this.controlName, '', [Validators.required])

    this.contributionModel$ = this.contributionOptions$.pipe(
      map((contributionOptions) => {
        return {
          title: 'Contribution year',
          controlName: this.controlName,
          options: this.mapContributionOptions(contributionOptions),
          validationMessage: 'Contribution year is required.'
        };
      })
    )

  }

  ngOnDestroy(): void {
    this.parentForm.removeControl(this.controlName);
  }

  mapContributionOptions(contributionOptions: string[]): OptionDropdown[] {
    return contributionOptions?.map(element => new OptionDropdown(element, element))
  }

  get contributionReason(): FormControl<string> {
    return this.parentForm.controls.contributionReason as FormControl<string>;
  }
}
